import React from 'react';

export const ReportIcon = () => {
    return (
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M512 64C264.64 64 64 264.64 64 512c0 247.424 200.64 448 448 448 247.488 0 448-200.576 448-448 0-247.36-200.512-448-448-448zm0 704c-26.432 0-48-21.504-48-48s21.568-48 48-48c26.624 0 48 21.504 48 48s-21.376 48-48 48zm48-240c0 26.56-21.376 48-48 48-26.432 0-48-21.44-48-48V304c0-26.56 21.568-48 48-48 26.624 0 48 21.44 48 48v224z"/></svg>
    )
}

export const AddIcon = () => {
    return (
        <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g className="svg-element" id="Wazzup-XL" transform="translate(-1062.000000, -848.000000)" fill="#FFFFFF">
                    <g id="Group-2" transform="translate(1046.000000, 833.000000)">
                        <g id="Group-6" transform="translate(16.000000, 15.000000)">
                            <rect id="Rectangle" x="6" y="0" width="2" height="14" rx="1"></rect>
                            <rect id="Rectangle" transform="translate(7.000000, 7.000000) rotate(-270.000000) translate(-7.000000, -7.000000) " x="6" y="0" width="2" height="14" rx="1"></rect>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const AddImageIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#ffffff" d="M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    );
};

export const SendIcon = () => {
    return (
        <svg width="20px" height="18px" viewBox="0 0 20 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vrienden-XL" transform="translate(-1392.000000, -923.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <g id="Group-8" transform="translate(260.000000, 120.000000)">
                        <g id="Group-5" transform="translate(375.000000, 784.000000)">
                            <g id="nav">
                                <g id="Group-10">
                                    <g transform="translate(260.000000, 10.000000)">
                                        <g id="Group" transform="translate(487.000000, -0.000000)">
                                            <g id="send-24px" transform="translate(8.000000, 6.000000)">
                                                <path d="M3.4,20.4 L20.85,12.92 C21.66,12.57 21.66,11.43 20.85,11.08 L3.4,3.6 C2.74,3.31 2.01,3.8 2.01,4.51 L2,9.12 C2,9.62 2.37,10.05 2.87,10.11 L17,12 L2.87,13.88 C2.37,13.95 2,14.38 2,14.88 L2.01,19.49 C2.01,20.2 2.74,20.69 3.4,20.4 Z" id="Path"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const PlusIcon = () => {
    return (
        <svg width="18px" height="18px" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vrienden-XL" transform="translate(-895.000000, -923.000000)" fill="#FFFFFF">
                    <g id="Group-8" transform="translate(260.000000, 120.000000)">
                        <g id="Group-5" transform="translate(375.000000, 784.000000)">
                            <g id="nav">
                                <g id="Group-10">
                                    <g transform="translate(260.000000, 10.000000)">
                                        <g id="Group-6" transform="translate(0.000000, 9.000000)">
                                            <path d="M9,0 L9,0 C9.55228475,-1.01453063e-16 10,0.44771525 10,1 L10,17 C10,17.5522847 9.55228475,18 9,18 L9,18 C8.44771525,18 8,17.5522847 8,17 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 Z" id="Rectangle"></path>
                                            <path d="M9,0 L9,0 C9.55228475,-1.01453063e-16 10,0.44771525 10,1 L10,17 C10,17.5522847 9.55228475,18 9,18 L9,18 C8.44771525,18 8,17.5522847 8,17 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 Z" id="Rectangle" transform="translate(9.000000, 9.000000) rotate(-270.000000) translate(-9.000000, -9.000000) "></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const ChevronDownIcon = () => {
    return (
        <svg width="28px" height="23px" viewBox="0 0 28 23" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <filter x="-63.6%" y="-59.1%" width="227.3%" height="227.3%" filterUnits="objectBoundingBox" id="filter-1">
                    <feOffset dx="0" dy="2" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                    <feGaussianBlur stdDeviation="4" in="shadowOffsetOuter1" result="shadowBlurOuter1"></feGaussianBlur>
                    <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0" type="matrix" in="shadowBlurOuter1" result="shadowMatrixOuter1"></feColorMatrix>
                    <feMerge>
                        <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                        <feMergeNode in="SourceGraphic"></feMergeNode>
                    </feMerge>
                </filter>
            </defs>
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g className="svg-element" id="Deel-iets-met-de-wereld-XL" transform="translate(-915.000000, -365.000000)" fill="#5E4FFF">
                    <g id="Group-11" transform="translate(877.000000, 330.000000)">
                        <g id="Group" transform="translate(30.000000, 21.000000)">
                            <g id="Group-10">
                                <g id="Group-9">
                                    <g id="Group-7" filter="url(#filter-1)" transform="translate(22.000000, 22.000000) rotate(-360.000000) translate(-22.000000, -22.000000) ">
                                        <g id="Group-6" transform="translate(22.000000, 21.000000) rotate(-315.000000) translate(-22.000000, -21.000000) translate(17.000000, 16.000000)">
                                            <path d="M9,0 L9,0 C9.55228475,-1.01453063e-16 10,0.44771525 10,1 L10,9 C10,9.55228475 9.55228475,10 9,10 L9,10 C8.44771525,10 8,9.55228475 8,9 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 Z" id="Rectangle"></path>
                                            <path d="M5,4 L5,4 C5.55228475,4 6,4.44771525 6,5 L6,13 C6,13.5522847 5.55228475,14 5,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,5 C4,4.44771525 4.44771525,4 5,4 Z" id="Rectangle" transform="translate(5.000000, 9.000000) rotate(-270.000000) translate(-5.000000, -9.000000) "></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const BubbleIcon = () => {
    return (
        <svg width="10px" height="11px" viewBox="0 0 10 11" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g className="svg-element" id="Group-3" fill="#ffffff">
                    <path d="M1.37834189e-13,5.05859375 L1.13686838e-13,2.02929688 C1.07221256e-13,1.2326575 0.64580381,0.586853692 1.44244318,0.586853692 C1.81508535,0.586853692 2.1732685,0.731067745 2.44194731,0.989280606 C3.07517142,1.59784971 3.46018896,2.1028974 3.59699433,2.5044295 C4.5618318,5.33628633 6.69616703,8.16814317 10,11 C6.54604433,11 3.56928105,10.0133442 1.72899071,9.40317868 C0.9052481,9.13005911 0.309208866,8.93237305 1.13686838e-13,8.93237305 Z" id="Combined-Shape"></path>
                </g>
            </g>
        </svg>
    );
};

export const CloseIcon = () => {
    return (
        <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g className="svg-element" id="Group-2" transform="translate(7.000000, 7.000000) rotate(45.000000) translate(-7.000000, -7.000000) translate(-2.000000, -2.000000)" fill="#5E4FFF">
                    <path d="M9,0 L9,0 C9.55228475,-1.01453063e-16 10,0.44771525 10,1 L10,17 C10,17.5522847 9.55228475,18 9,18 L9,18 C8.44771525,18 8,17.5522847 8,17 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 Z" id="Rectangle"></path>
                    <path d="M9,0 L9,0 C9.55228475,-1.01453063e-16 10,0.44771525 10,1 L10,17 C10,17.5522847 9.55228475,18 9,18 L9,18 C8.44771525,18 8,17.5522847 8,17 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 Z" id="Rectangle" transform="translate(9.000000, 9.000000) rotate(-270.000000) translate(-9.000000, -9.000000) "></path>
                </g>
            </g>
        </svg>
    );
};

export const BackIcon = () => {
    return (
        <svg width="8px" height="14px" viewBox="0 0 8 14" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g className="svg-element" id="Vrienden-XL" transform="translate(-297.000000, -156.000000)" fill="#5E4FFF">
                    <g id="Group-8" transform="translate(260.000000, 120.000000)">
                        <g id="Group-5" transform="translate(0.000000, -1.000000)">
                            <g id="Group" transform="translate(0.000000, 22.000000)">
                                <g id="Group-7" transform="translate(43.000000, 22.000000) rotate(-270.000000) translate(-43.000000, -22.000000) translate(21.000000, 0.000000)">
                                    <g id="Group-6" transform="translate(22.000000, 21.000000) rotate(-315.000000) translate(-22.000000, -21.000000) translate(17.000000, 16.000000)">
                                        <path d="M9,0 L9,0 C9.55228475,-1.01453063e-16 10,0.44771525 10,1 L10,9 C10,9.55228475 9.55228475,10 9,10 L9,10 C8.44771525,10 8,9.55228475 8,9 L8,1 C8,0.44771525 8.44771525,1.01453063e-16 9,0 Z" id="Rectangle"></path>
                                        <path d="M5,4 L5,4 C5.55228475,4 6,4.44771525 6,5 L6,13 C6,13.5522847 5.55228475,14 5,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,5 C4,4.44771525 4.44771525,4 5,4 Z" id="Rectangle" transform="translate(5.000000, 9.000000) rotate(-270.000000) translate(-5.000000, -9.000000) "></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const CrossIcon = () => {
    return (
        <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g className="svg-element" id="Vrienden" transform="translate(-343.000000, -154.000000)" fill="#B3B3B3">
                    <g id="Group" transform="translate(-1.000000, 15.000000)">
                        <g id="Group-3" transform="translate(0.000000, 111.000000)">
                            <g id="Group-7" transform="translate(340.000000, 24.000000)">
                                <g id="Group-6" transform="translate(10.000000, 10.000000) rotate(-315.000000) translate(-10.000000, -10.000000) translate(3.000000, 3.000000)">
                                    <rect id="Rectangle" x="6" y="0" width="2" height="14" rx="1"></rect>
                                    <rect id="Rectangle" transform="translate(7.000000, 7.000000) rotate(-270.000000) translate(-7.000000, -7.000000) " x="6" y="0" width="2" height="14" rx="1"></rect>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const LoadingIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle className="svg-element" cx="50" cy="50" fill="none" stroke="#ffffff" strokeWidth="10" r="35" strokeDasharray="164.93361431346415 56.97787143782138" transform="rotate(354.037 50.0002 50.0002)">
            <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
            </circle>
        </svg>
    );
};

export const ChatIcon = () => {
    return (
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vrienden-XL" transform="translate(-1023.000000, -922.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <g id="Group-8" transform="translate(260.000000, 120.000000)">
                        <g id="Group-5" transform="translate(376.000000, 48.000000)">
                            <g id="nav" transform="translate(0.000000, 736.000000)">
                                <g id="Group">
                                    <g transform="translate(385.000000, 16.000000)">
                                        <g id="forum-24px-(1)">
                                            <path d="M20,6 L19,6 L19,14 C19,14.55 18.55,15 18,15 L6,15 L6,16 C6,17.1 6.9,18 8,18 L18,18 L22,22 L22,8 C22,6.9 21.1,6 20,6 Z M17,11 L17,4 C17,2.9 16.1,2 15,2 L4,2 C2.9,2 2,2.9 2,4 L2,17 L6,13 L15,13 C16.1,13 17,12.1 17,11 Z" id="Shape"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const HomeIcon = () => {
    return (
        <svg width="20px" height="17px" viewBox="0 0 20 17" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vrienden-XL" transform="translate(-1139.000000, -923.000000)" fill="#FFFFFF" fillRule="nonzero">
                    <g id="Group-8" transform="translate(260.000000, 120.000000)">
                        <g id="Group-5" transform="translate(376.000000, 48.000000)">
                            <g id="nav" transform="translate(0.000000, 736.000000)">
                                <g id="Group">
                                    <g transform="translate(385.000000, 16.000000)">
                                        <g id="home-24px-(2)" transform="translate(116.000000, 0.000000)">
                                            <path d="M10,19 L10,14 L14,14 L14,19 C14,19.55 14.45,20 15,20 L18,20 C18.55,20 19,19.55 19,19 L19,12 L20.7,12 C21.16,12 21.38,11.43 21.03,11.13 L12.67,3.6 C12.29,3.26 11.71,3.26 11.33,3.6 L2.97,11.13 C2.63,11.43 2.84,12 3.3,12 L5,12 L5,19 C5,19.55 5.45,20 6,20 L9,20 C9.55,20 10,19.55 10,19 Z" id="Path"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const GroupIcon = () => {
    return (
        <svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vrienden-XL" transform="translate(-1254.000000, -922.000000)" fill="#fff">
                    <g id="Group-8" transform="translate(260.000000, 120.000000)">
                        <g id="Group-5" transform="translate(376.000000, 48.000000)">
                            <g id="nav" transform="translate(0.000000, 736.000000)">
                                <g id="Group">
                                    <g transform="translate(385.000000, 16.000000)">
                                        <g id="people-24px" transform="translate(233.000000, 2.000000)">
                                            <circle id="Oval" cx="10" cy="3" r="3"></circle>
                                            <circle id="Oval" cx="10" cy="17" r="3"></circle>
                                            <circle id="Oval" cx="3" cy="10" r="3"></circle>
                                            <circle id="Oval" cx="17" cy="10" r="3"></circle>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const DotsIcon = () => {
    return (
        <svg width="26px" height="6px" viewBox="0 0 26 6" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Vriend-verwijderen" transform="translate(-328.000000, -34.000000)" fill="#FFFFFF">
                    <g id="Group-8" transform="translate(328.000000, 34.000000)">
                        <g id="Group-9">
                            <circle id="Oval" cx="3" cy="3" r="3"></circle>
                            <circle id="Oval" cx="13" cy="3" r="3"></circle>
                            <circle id="Oval" cx="23" cy="3" r="3"></circle>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const EditIcon = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24"><path fill="#ffffff" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"/><path d="M0 0h24v24H0z" fill="none"/></svg>
    );
};

export const RemoveIcon = () => {
    return (
        <svg viewBox="0 0 14 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="delete-24px-(1)" transform="translate(-5.000000, -3.000000)">
                    <path className="svg-element" d="M6,19 C6,20.1 6.9,21 8,21 L16,21 C17.1,21 18,20.1 18,19 L18,7 L6,7 L6,19 Z M19,4 L15.5,4 L14.5,3 L9.5,3 L8.5,4 L5,4 L5,6 L19,6 L19,4 Z" id="Shape" fill="#FFFFFF" fillRule="nonzero"></path>
                    <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                </g>
            </g>
        </svg>
    );
};

export const EventIcon = () => {
    return (
        <svg width="18px" height="20px" viewBox="0 0 18 20" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="design" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Meetings" transform="translate(-46.000000, -130.000000)">
                    <g id="Group-7" transform="translate(20.000000, 105.000000)">
                        <g id="Bitmap" transform="translate(15.000000, 15.000000)">
                            <g id="event-24px" transform="translate(8.000000, 8.000000)">
                                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                <path d="M16,13 L13,13 C12.45,13 12,13.45 12,14 L12,17 C12,17.55 12.45,18 13,18 L16,18 C16.55,18 17,17.55 17,17 L17,14 C17,13.45 16.55,13 16,13 Z M16,3 L16,4 L8,4 L8,3 C8,2.45 7.55,2 7,2 C6.45,2 6,2.45 6,3 L6,4 L5,4 C3.89,4 3.01,4.9 3.01,6 L3,20 C3,21.1 3.89,22 5,22 L19,22 C20.1,22 21,21.1 21,20 L21,6 C21,4.9 20.1,4 19,4 L18,4 L18,3 C18,2.45 17.55,2 17,2 C16.45,2 16,2.45 16,3 Z M18,20 L6,20 C5.45,20 5,19.55 5,19 L5,9 L19,9 L19,19 C19,19.55 18.55,20 18,20 Z" id="Shape" fill="#FFFFFF" fillRule="nonzero"></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const ZoomIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white" ><path d="M0 0h24v24H0V0z" fill="none"/><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/><path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/></svg>
    );
};

export const CheckIcon = () => {
    return (
        <svg width="13px" height="10px" viewBox="0 0 13 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Group-11" transform="translate(6.281225, 3.429254) rotate(42.000000) translate(-6.281225, -3.429254) translate(2.781225, -2.070746)" fill="#FFFFFF">
                    <rect x="0" y="9" width="7" height="2" rx="1"></rect>
                    <rect transform="translate(6.000000, 5.500000) rotate(-270.000000) translate(-6.000000, -5.500000) " x="0.5" y="4.5" width="11" height="2" rx="1"></rect>
                </g>
            </g>
        </svg>
    );
};